<template>
  <div class="fangancont between">
    <div class="hotfangan">
      <div class="hea">热门方案</div>
      <div class="cont">
        <div
          class="hotfnitem flex_start"
          v-for="(item, index) in solulist"
          :key="index"
          @click="tojump(item)"
        >
          <div class="cove">
            <img src="../../../assets/jpcol/artic2_sample.png" alt="" />
          </div>
          <div class="text">
            <div class="text1">{{ item.title }}</div>
            <div class="text2">
              {{ item.daod | toEllipsisFilter(70) }}
            </div>
            <div class="text3 flex_start">
              <img src="../../../assets/base/kan.png" alt="" />
              <div>{{ item.view_num }}次浏览</div>
              <img src="../../../assets/base/dianzan.png" v-if="true" />
              <img src="../../../assets/base/dianzan_active.png" v-if="false" />
              <div>{{ item.like_num }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination" v-if="solulist.length != 0">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-count="pageCount"
          :current-page="currentPage"
          @current-change="turnpage"
          @prev-click="turnpage(--currentPage)"
          @next-click="turnpage(++currentPage)"
        >
        </el-pagination>
        <div class="textnum">[共{{ pageCount }}页]</div>
      </div>
    </div>
    <div class="fanganright">
      <fanganys class="jjfays" />
      <fghotj class="hotfatj mt30" />
      <!-- <fangancalc class="syjsq mt30"/> -->
    </div>
  </div>
</template>

<script>
import fanganys from "../components/fanganys";
import fghotj from "../components/fghotj";
import fangancalc from "../components/fangancalc";
export default {
  components: {
    fanganys,
    fghotj,
    fangancalc,
  },
  props:['data'],
  data: () => ({
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
    solulist: [],
  }),
  computed: {
    catId() {
      return this.$store.state.jpcol.soluId?this.$store.state.jpcol.soluId:this.$route.params.cat_id;
    },
  },
  beforeMount() {
    this.getsolu();
  },
  methods: {
    turnpage(e) {
      console.log(e);
      this.currentPage = e;
      this.getsolu();
    },
    tojump(item) {
      this.$router.push({
        path: "/jpcol/fgartic",
        query:{
          faId:item.id
        }
      });
    },
    getsolu() {
      let data = {
        page: this.currentPage,
        cat_id: this.catId,
        limit: 6,
      };
      data.cat_id == 0 ? delete data.cat_id : "";
      this.$http.jpcol
        .getsolutionlist(data)
        .then((res) => {
          this.pageCount = res.data.last_page;
          this.total = res.data.count;
          this.solulist = res.data.data;
        })
        .catch((err) => {});
    },
  },
  watch: {
    catId() {
      console.log("catId变了");
      this.getsolu();
    },
  },
};
</script>

<style lang="scss" scoped>
.fangancont {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  align-items: flex-start;

  .hotfangan {
    width: 855px;
    padding-bottom: 30px;
    background: #fff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    .hea {
      font-size: 24px;
      color: #333333;
      line-height: 24px;
      padding: 18px 22px;
      border-bottom: 1px solid #eee;
    }
    .cont {
      .hotfnitem {
        padding: 30px 24px;
        border-bottom: 1px solid #eee;
        align-items: flex-start;
        &:hover {
          .text1 {
            color: #0465ea;
          }
        }
        .cove {
          img {
            width: 280px;
            height: 160px;
          }
        }
        .text {
          margin-left: 26px;
          cursor: pointer;
        }
        .text1 {
          font-size: 18px;
          color: #333333;
          line-height: 18px;
          margin-top: 18px;
        }
        .text2 {
          margin-top: 20px;
          font-size: 14px;
          color: #666666;
          line-height: 26px;
        }
        .text3 {
          margin-top: 18px;
          font-size: 12px;
          color: #999999;
          img {
            margin-right: 8px;
          }
          div {
            margin-right: 28px;
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .pagination {
      text-align: center;
      margin-top: 30px;
      .textnum {
        color: #333;
        margin-top: 15px;
      }
    }
  }
  .fanganright {
    width: 315px;
    .jjfays {
      width: 100%;
      height: 332px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    }
    .hotfatj {
      width: 100%;
      height: 278px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    }
    .syjsq {
      width: 100%;
      height: 260px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    }
  }
}
</style>
            